import { ca } from '@cian/analytics';

export const trackShowRecommendations = (offerId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Show_sopr',
    label: 'Messages',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};

export const trackClickRecommendation = (offerId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_similar_offers',
    label: 'user-based',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};
